function syncSingleStickybarItem(variantId, newQty){
  let storedItems = JSON.parse(localStorage.getItem('stickybar_products')) || [];
  const existingItemIndex = storedItems.findIndex(item => item.id === variantId);
  if(existingItemIndex !== -1){
    if(newQty === 0){
      storedItems.splice(existingItemIndex, 1);
    }else{
      storedItems[existingItemIndex].quantity = newQty;
    }
    localStorage.setItem('stickybar_products', JSON.stringify(storedItems));
    renderStickyBarItems(storedItems); // Update .cbg-stickybar-left ul
  }
}
function cartVariant(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
      updateItem(new_line, new_qty);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(centerQtyInput.value);
      if(currentQty > 0){
        centerQtyInput.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        updateItem(newLine, newQty);
      }
    });
  });
  document.querySelectorAll('.cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.cartitems').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.cartitems').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.cartitems').querySelector('.cart_qty').value;
      let formData = {
        'items': [{'id': changevar_id,'quantity': item_current_qty}]
      };
      console.log('formData',formData);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        console.log('successs');
        setTimeout(function(e){
          updateItem(currentid,0);
        },500);
      })
      .catch((error) => {
        console.error('error',error);
        cart_error.text(e.responseJSON.description);
        setTimeout(function(){
          cart_error.text('');
        },2000);
      });
    })
  })
  let cdVariantBox = document.querySelectorAll(".cd_variant_cls");
  let opencdVariantBox = (variantBox) => {variantBox.classList.add("active");}
  let closecdVariantBox = (variantBox) => {variantBox.classList.remove("active");}
  cdVariantBox.forEach((variantBox) => {
    let btn = variantBox.querySelector(".cd_variantbtn");
    if(btn) btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantBox.forEach((box) => {
        if(box !== variantBox){closecdVariantBox(box);}
      });
      if(variantBox.classList.contains("active")){
        closecdVariantBox(variantBox);
      }else{
        opencdVariantBox(variantBox);
      }
    });
  });
}
function getCurrentCountry(){
  fetch('https://ipinfo.io/json')
    .then(response => response.json())
    .then(data => {
      document.querySelectorAll('.cd-shipping-inr').forEach((shipping) =>{
        let country = shipping.getAttribute('data-country');
        if(country.includes(data.country)){
          shipping.style.display = 'block';
        }
      })
    })
    .catch(error => console.error('Error fetching the country data:', error));
}
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;
      cartRemove.addEventListener('click',(evt) => {
        updateItem(data_line,0);
        // Check if the removed item is the gift wrapping product
        if(document.querySelector('.gift-wrapping-checkbox-label')){
          const giftWrappingLabel = document.querySelector('.gift-wrapping-checkbox-label');
          const productId = giftWrappingLabel.getAttribute('data-product-id');
          if (data_line == productId) {
            // Untoggle the checkbox if the gift wrapping product is removed
            giftWrappingLabel.classList.remove('checked');
            localStorage.setItem('giftWrappingChecked', false);
          }
        }
      });
    });
    
    let drawerRelated = new Swiper(".cd-related-products",{
      slidesPerView: "auto",
      slidesPerGroup: 2,
      loop: false,
      pagination:{
        el:".cd-related-prod-wrap .swiper-pagination",
        clickable: true
      },
      breakpoints: {
       768: {
          slidesPerGroup: 1,
        },
      }
    });
    let drawerConsider = new Swiper(".cd-consider-products",{
      slidesPerView: "auto",
      slidesPerGroup: 2,
      loop: false,
      pagination:{
        el:".cd-consider-prod-wrap .swiper-pagination",
        clickable: true
      },
      breakpoints: {
       768: {
          slidesPerGroup: 1,
        },
      }
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        if(document.querySelector('.snippet-menu-drawer')) document.querySelector('.snippet-menu-drawer').style.height = '';
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','active-popup');
        document.querySelector('body').classList.add('open-drawer');
        if(drawerRelated) drawerRelated.update();
        if(drawerConsider) drawerConsider.update();
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        if(document.querySelector(".accordian-content.active")) document.querySelector(".accordian-content.active").classList.remove("active");
        if(document.querySelector(".accordian-wrap.active")) document.querySelector(".accordian-wrap.active").classList.remove("active");
        document.querySelector('body').classList.remove('open-quick-buy','open-drawer','open-menu','open-search','open-sort','open-filter','active-popup','active-popup');
        resizeMenuDrawer();
      });
    });
    
    let cdRelatedVariant = document.querySelectorAll(".grid-variant-outer");
    let openRelatedVariant = (relatedVariant) => {relatedVariant.classList.add("active");}
    let closeRelatedVariant = (relatedVariant) => {relatedVariant.classList.remove("active");}
    cdRelatedVariant.forEach((relatedVariant) => {
      let btn = relatedVariant.querySelector(".cd-select-btn");
      if(btn) btn.addEventListener("click", (e) => {
        e.preventDefault();
        var drawerMiddle = document.querySelector('.cd_middle');
        if(document.querySelector('.cd_middle:has(.free-shipping)')){
          var targetSection = drawerMiddle.querySelector('.cd-related-prod-wrap');
          if(document.querySelectorAll('.grid-variant-outer.active').length > 0){
            drawerMiddle.scroll({
              top: targetSection.offsetTop + targetSection.scrollHeight - drawerMiddle.clientHeight,
              behavior: 'smooth'
            });
          }else{
            drawerMiddle.scroll({
              top: targetSection.offsetTop + targetSection.scrollHeight + document.querySelector('.cd-related-prod-wrap .grid-size-variants').offsetHeight - drawerMiddle.clientHeight,
              behavior: 'smooth'
            });
          }
        }else{
          var targetSection = drawerMiddle.querySelector('.cd-consider-prod-wrap');
          if(document.querySelectorAll('.grid-variant-outer.active').length > 0){
            drawerMiddle.scroll({
              top: targetSection.offsetTop + targetSection.scrollHeight - drawerMiddle.clientHeight,
              behavior: 'smooth'
            });
          }else{
            drawerMiddle.scroll({
              top: targetSection.offsetTop + targetSection.scrollHeight + document.querySelector('.cd-consider-prod-wrap .grid-size-variants').offsetHeight - drawerMiddle.clientHeight,
              behavior: 'smooth'
            });
          }
        }
        if(relatedVariant.classList.contains("active")){
          closeRelatedVariant(relatedVariant);
        }else{
          openRelatedVariant(relatedVariant);
        }
      });
    });
    function matchHeight(selector){
      let elements = document.querySelectorAll(selector);
      let maxHeight = 0;
      elements.forEach(element => {
        element.style.height = 'auto';
      });
      elements.forEach(element => {
        let height = element.offsetHeight;
        if(height > maxHeight){maxHeight = height;}
      });
      elements.forEach(element => {
        element.style.height = maxHeight + 'px';
      });
    }
    matchHeight('.grid-meta-top:has(.grid-variant-outer) .grid-title');
    window.addEventListener('resize', () => {
      matchHeight('.grid-meta-top:has(.grid-variant-outer) .grid-title');
    });
    cartVariant();
    getCurrentCountry();
    quickAddButton();
    toggleGiftWrapping();
    setTimeout(() => {
      document.querySelectorAll('.cd-usps-slider').forEach(function(Element,index){
        let productid = Element.dataset.id;
        let outer_carousel = Element.closest('.cd-usps');
        let pagination = outer_carousel.querySelectorAll('.swiper-pagination')[0];
        let swiper = new Swiper(Element,{
          loop: true,
          slidesPerView: "auto",
          a11y: false,
          pagination: {
            el: pagination,
            clickable: true
          },
          speed:1000,
          autoplay: {
           delay: 3000,
           disableOnInteraction: false,
         },
        })
      });
    }, 1000);
    if (typeof countBundleItemsInCart == 'function') {
      countBundleItemsInCart();
    }
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      // document.querySelector('.cart-count').innerHTML = ' ('+cart_count+')';
      if(cart_count>0){
        document.querySelector('.cart-count').innerHTML = cart_count;
        document.querySelector('.cart-count-wrapper').style.display = 'flex';
      } else {
        document.querySelector('.cart-count-wrapper').style.display = 'none';
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    load_cart();
  }
});
load_cart();
function updateItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }         
    }
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      if(window.location.pathname.includes('/pages/custom-builder')){
        const cartItem = data.items.find(item => item.variant_id === parseInt(data_line));
        const actualQty = cartItem ? cartItem.quantity : 0;
        syncSingleStickybarItem(parseInt(data_line), actualQty);
      }
      if (document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      } else {
        if (typeof load_cart === 'function') {
          load_cart();
          setTimeout(() => {
            document.querySelector('body').classList.add('open-drawer');
          }, 500);
        } else {
          window.location.href = "/cart";
        }
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
document.body.addEventListener('click', function(e) {
  var cartVariantBtns = document.querySelectorAll('.cd_variantbtn, .cd__variant_list,.cd-select-btn,.cd-variant-wrap');
  var clickedInside = Array.from(cartVariantBtns).some(function(element) {
    return element.contains(e.target) || element === e.target;
  });
  if (!clickedInside){
    document.querySelectorAll('.cd_variant_cls,.grid-variant-outer').forEach(function(element) {
      element.classList.remove('active');
    });
  }
});

function toggleGiftWrapping() {
  const giftWrappingLabel = document.querySelector('.gift-wrapping-checkbox-label');
  
  if (giftWrappingLabel) {
    const isChecked = localStorage.getItem('giftWrappingChecked') === 'true';
    if (isChecked) {
      giftWrappingLabel.classList.add('checked');
    }

    giftWrappingLabel.addEventListener('click', function() {
      this.classList.toggle('checked');
      const productId = this.getAttribute('data-product-id');

      // Save the state to local storage
      localStorage.setItem('giftWrappingChecked', this.classList.contains('checked'));
      
      if (this.classList.contains('checked')) {
        // Add gift wrapping product to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              quantity: 1,
              id: productId
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          updateItem(data.items[0].id, 1);
        })
        .catch(error => {
          console.error('Error adding product:', error);
        });
      } else {
        // Remove gift wrapping product from cart
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(item => item.variant_id == productId);
            if (item) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: 0
                })
              })
              .then(response => response.json())
              .then(data => {
                updateItem(item.key, 0);
              })
              .catch(error => {
                console.error('Error removing product:', error);
              });
            }
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
          });
      }
    });
  }
}